// @ts-nocheck
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import {
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;
type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

export const PopulateApiParameterWithDynamicValues: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    const { topic, firstName, lastName, phoneNumber, emailAddress, message, emailRecipients, ...properties } =
        state.fieldValues;

    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
        properties,
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterWithDynamicValues);
